// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=testing` then `environment.testing.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
    apiVersion: '1',
    appName: 'Donor-portal',
    appVersion: '1.0.0',
    assetsPath: 'assets/',
    authClientId: 2,
    authSecretVariable: 'R87Y6E7EJAKH',
    baseApiUrl: 'https://portal.staging.twesb.com',
    calendlyInPersonUrl: 'https://calendly.com/tweb/miles-tech-testing-tweb-in-person-disregard',
    calendlyVirtualUrl: 'https://calendly.com/tweb/miles-tech-testing-tweb-disregard',
    docPath: 'docs/',
    googleApiKey: '', // Empty this string to disable google login
    helloSignTestMode: true,
    imgPath: 'docs/images/',
    logger: false,
    production: false,
    s3ImgPath: 'https://cdn.staging.theworldeggbank.com', // S3 bucket
    siteName: 'donor-portal',
    submitHelpUrl: 'http://submit-help.testing.milesapp.com',
    useLocalImages: false,
};
